/**
 * @generated SignedSource<<3ab215d1ea6c83ab548fb399e28e94b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_user">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_user";
};
export type PdpSharedShoppingButtons_user$key = {
  readonly " $data"?: PdpSharedShoppingButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2ead236824a0096cdd202f5906984d7f";

export default node;
